export const MAINNET_URL = "https://canto-testnet.plexnode.wtf"; //"https://eth-sepolia.g.alchemy.com/v2/D86FGA2fWaU2ATyNWU8OPANGeZV6NG4a";

export const SWAP_ROUTER_ADDRESS = "0xD51C75be4C264b48724F7913fa142b22b2A8D497";
export const QUOTER_ADDRESS = "0x362e18b27477566D318765D0582A3FF2596d84B0";
export const QUOTER_V2_ADDRESS = "0x0d18f4362011Fd0D32284C781689e1e4522ca4cE";
export const FACOTRY_ADDRESS = "0x574Cd7E160e22C9300302192b9009d0496189e0F";
export const NON_FUNGIBLE_MANAGER = "0xB519e47Eef3A2b1088E6f0E0d11657DC85385f24";
export const NON_FUNGIBLE_DESCRIPTOR = "0x011f56d5A6d83aC63d92F85C54f3a573aECEc500";
export const WCANTO_ADDRESS = "0xd6307DBAdc6398308307f5E60f2544220B48ba94";
export const USERSTORAGE_ADDRESS = "0x2cF49a83f2686b2D3452Ad4Fa5EFeeFE65209706";
